function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddClassroom = function SvgAddClassroom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 910 430",
    style: {
      enableBackground: "new 0 0 910 430"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "newClassroomIconSmallGirl1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#694B4B"
    },
    d: "M617.4,132.5c-82.1,0-73,99.9-72.7,172.3c0,2.7,1.4,5.2,3.8,6.6c9.1,5.5,34.1,18.3,68.9,18.3 s59.8-12.8,68.9-18.3c2.3-1.4,3.8-3.9,3.8-6.6C690.4,232.4,699.5,132.5,617.4,132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A4146"
    },
    d: "M612.1,132.7c-76.4,4.3-67.7,101.3-67.4,172.1c0,2.7,1.4,5.2,3.8,6.6c9.1,5.5,34.1,18.3,68.9,18.3 l20.8-145.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#694B4B"
    },
    d: "M617.4,132.5c-46.7,0-49.9,56.4-49.9,56.4c26.9-4.5,43.5,6.8,70.7-4.5l-20.8,145.3 c34.8,0,59.8-12.8,68.9-18.3c2.3-1.4,3.8-3.9,3.8-6.6C690.4,232.4,699.5,132.5,617.4,132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#785550"
    },
    d: "M690,304.8c0.3-62.2,7-144.7-43.2-166.6c-0.9,4.6-2.5,17.3,1.7,25.5c10.4,20.8,20.8,20.8,31.1,36.3 c10.4,57.1-19.8,117.7-29.9,125.9l0,0c17.8-4.2,30.5-10.9,36.5-14.5C688.6,310,690,307.5,690,304.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6AF78"
    },
    d: "M696,320.5l-46.3-19.3c-3.9-1.6-6.4-5.4-6.4-9.6v-12.5h-51.9v12.5c0,4.2-2.5,8-6.4,9.6l-46.3,19.3 c-5.8,2.4-9.6,8.1-9.6,14.4v20.8c0,5.7,4.6,10.4,10.4,10.4h155.7c5.7,0,10.4-4.6,10.4-10.4v-20.8 C705.6,328.6,701.8,322.9,696,320.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M696,320.5l-44.8-18.7l-33.9,14.6l-33.9-14.6l-44.8,18.7c-5.8,2.4-9.6,8.1-9.6,14.4v20.8 c0,5.7,4.6,10.4,10.4,10.4h155.7c5.7,0,10.4-4.6,10.4-10.4v-20.8C705.6,328.6,701.8,322.9,696,320.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D29B6E"
    },
    d: "M643.3,279.1h-51.9v12.5c0,4.2-2.5,8-6.4,9.6l-7.2,3C633.2,318.4,643.3,279.1,643.3,279.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF6"
    },
    d: "M554.5,340.6L533.6,324c-2.8,2.9-4.5,6.7-4.5,10.9v20.8c0,5.7,4.6,10.4,10.4,10.4h20.8v-13.3 C560.3,348,558.1,343.6,554.5,340.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF6"
    },
    d: "M705.6,355.7v-20.8c0-4.1-1.6-8-4.4-10.8l-20.9,16.5c-3.7,3-5.8,7.4-5.8,12.2V366h20.8 C701,366,705.6,361.4,705.6,355.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF6"
    },
    d: "M618.2,355.7h-1.6c-2.4,0-4.4-2-4.4-4.4v-34.7h10.4v34.7C622.6,353.7,620.6,355.7,618.2,355.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF6"
    },
    d: "M617.4,316.5l-29.7-22.3c-1.9-1.4-4.6-1-5.9,1l-5.9,8.8l18.2,25.5c1.4,1.9,4.1,2.3,6,0.8 L617.4,316.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF6"
    },
    d: "M617.4,316.5l29.7-22.3c1.9-1.4,4.6-1,5.9,1l5.9,8.8l-18.2,25.5c-1.4,1.9-4.1,2.3-6,0.8 L617.4,316.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C087"
    },
    d: "M643.3,179.2c-25.9,25.9-76.9,5.2-76.9,46.7l3.2,30.6c0.6,6.8,4.6,12.9,10.6,16.3l29.5,16.4 c4.7,2.6,10.4,2.6,15.1,0l29.5-16.4c6-3.3,10-9.4,10.6-16.3l3.7-36.3c0.3-2.6,0.3-5.2,0.2-7.8C667.1,199.2,648.5,189.6,643.3,179.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6AF78"
    },
    d: "M566.5,225.9l3.2,30.6c0.6,6.8,4.6,12.9,10.6,16.3l29.5,16.4c3.3,1.8,7,2.3,10.6,1.6l0,0 c0,0-14.9-4.5-23.8-28.5c-2.7-7.4-6.5-46.3-3.2-51c6.4-9.4,42.2-10.4,52.7-27.8c-0.5-0.6-1-1.3-1.4-1.9c0-0.1-0.1-0.1-0.1-0.2 c-0.5-0.7-0.9-1.4-1.2-2.1C617.4,205.2,566.5,184.4,566.5,225.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF6"
    },
    d: "M655.3,355.7h-13.5c-4.9,0-8.8,4-8.8,8.8v1.6h31.1v-1.6C664.1,359.6,660.1,355.7,655.3,355.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "newClassroomIconSmallBoy1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6AF78"
    },
    points: "337,308 337,279.5 263.7,279.5 263.7,308 300.3,340.6  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M393.6,321.3l-50.4-11.9c-0.8-0.2-1.5-0.5-2.1-0.9l-40.8,23.8l-39.2-25c-1,1-2.3,1.7-3.7,2 L207,321.3c-7.4,1.7-12.6,8.3-12.6,15.9v31.9c0,4.5,3.6,8.1,8.1,8.1H398c4.5,0,8.1-3.6,8.1-8.1v-31.9 C406.2,329.6,401,323.1,393.6,321.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D29B6E"
    },
    d: "M263.7,279.5v30.1c46.2,16.6,73.3-25,73.3-25v-5.1H263.7L263.7,279.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C087"
    },
    d: "M247.4,185.8l3.5,78.1c0.3,7.3,3.9,14.1,9.7,18.4l16.8,12.6c4.2,3.2,9.4,4.9,14.7,4.9h16.3 c5.3,0,10.4-1.7,14.7-4.9l16.8-12.6c5.8-4.4,9.4-11.1,9.7-18.4l3.5-78.1L247.4,185.8L247.4,185.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6AF78"
    },
    d: "M288.1,202.1c16.3,0,40.7-4.1,46.5-16.3h-87.2l3.5,78.1c0.3,7.3,3.9,14.1,9.7,18.4l16.8,12.6 c4.2,3.2,9.4,4.9,14.7,4.9h8.1c-8.1,0-24.4-16.3-24.4-36.6c0-10,0-36.6,0-48.9C275.9,210.3,280,202.1,288.1,202.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF6"
    },
    d: "M376.3,350.8l26.4-23.7c2.2,2.8,3.5,6.3,3.5,10.1v31.9c0,4.5-3.6,8.1-8.1,8.1h-28.5v-11.3 C369.5,360.1,372,354.6,376.3,350.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B5D6E"
    },
    points: "310.5,377.2 290.1,377.2 292.7,340.6 307.9,340.6  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515262"
    },
    d: "M310.5,332.4h-20.4v2.4c0,5.4,4.4,9.9,9.9,9.9h0.6c5.4,0,9.9-4.4,9.9-9.9L310.5,332.4L310.5,332.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF6"
    },
    d: "M263.1,298.9l37.2,33.5c0,0-10.4,5.3-23.3,15.9c-2.7,2.2-6.7,1.3-8.1-1.8L251.4,308l5.5-8.3 C258.4,297.6,261.2,297.3,263.1,298.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF6"
    },
    d: "M337.5,298.9l-37.2,33.5c0,0,10.4,5.3,23.3,15.9c2.7,2.2,6.7,1.3,8.1-1.8l17.5-38.5l-5.5-8.3 C342.3,297.6,339.4,297.3,337.5,298.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#785550"
    },
    d: "M325,158.9l3.8,27c17.4,3.5,19.9,30.8,20.3,38.6c0.1,1.4,0.5,2.8,1.3,4l6.6,10.3 c0,0-2.3-17.1,8.1-28.5C365.2,210.3,368.8,142.6,325,158.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C087"
    },
    d: "M361.1,237l-4.6,18.4c-0.5,2.2-2.5,3.7-4.7,3.7l0,0c-2.5,0-4.6-1.8-4.9-4.3l-2.4-18.8 c-0.6-5,3.3-9.5,8.4-9.5h0C358.4,226.6,362.5,231.7,361.1,237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#694B4B"
    },
    d: "M251.3,151.6l6,4.1c-27.2,20.1-22.1,54.6-22.1,54.6c8.1,8.1,8.1,28.5,8.1,28.5l8.1-8.1 c0,0-3.1-23.5,12.2-32.6c14.3-8.4,26.7-4.1,39.4-4.1c34.1,0,43.6-12.9,42-28.5c-0.9-8.1-13.2-25-44.8-24.4 C287.6,141.3,263.7,145.1,251.3,151.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A4146"
    },
    d: "M248.9,190.4c0,0-4.3-17.1,8.4-34.7c-27.2,20.1-22.1,54.6-22.1,54.6c8.1,8.1,8.1,28.5,8.1,28.5 l8.1-8.1c0,0-3.1-23.5,12.2-32.6c14.3-8.4,26.7-4.1,39.4-4.1c5.5,0,10.4-0.4,14.7-1C291.5,193.8,276,174,248.9,190.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6AF78"
    },
    d: "M239.5,237l4.6,18.4c0.5,2.2,2.5,3.7,4.8,3.7l0,0c2.5,0,4.6-1.8,4.9-4.3L256,236 c0.6-5-3.3-9.5-8.4-9.5h0C242.2,226.6,238.2,231.7,239.5,237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF6"
    },
    d: "M349.2,369.1h-20.4c-4.5,0-8.1,3.6-8.1,8.1l0,0h36.6l0,0C357.3,372.7,353.7,369.1,349.2,369.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "newClassroomIconSmallBoy2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A4146"
    },
    d: "M560.4,158.4v5.8c0,7.1,1.1,14.2,3.4,20.9l13.1,39.4h24.8v-90.8h-16.5 C571.5,133.7,560.4,144.7,560.4,158.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#694B4B"
    },
    d: "M673.5,175.6l-14,48.9l-66.1-57.8c-9.1,0-16.5-7.4-16.5-16.5l0,0c0-13.7,11.1-24.8,24.8-24.8h57.8 c9.1,0,16.5,7.4,16.5,16.5v15.5C676,163.6,675.1,169.7,673.5,175.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.4,
    y: 249.3,
    style: {
      fill: "#E6AF78"
    },
    width: 49.5,
    height: 36.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D29B6E"
    },
    d: "M593.4,264.4c7.7,3.1,16,4.9,24.8,4.9s17.1-1.8,24.8-4.9v-15.2h-49.5L593.4,264.4L593.4,264.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DCED"
    },
    d: "M682.8,280.7L643,269.3l-24.8,16.4l-24.8-16.4l-39.8,11.4c-10.6,3-18,12.8-18,23.8v60.4 c0,4.6,3.7,8.3,8.3,8.3h148.6c4.6,0,8.3-3.7,8.3-8.3v-60.4C700.8,293.4,693.4,283.7,682.8,280.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AFB9D2"
    },
    points: "626.4,373.1 609.9,373.1 614.1,285.8 622.3,285.8  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C087"
    },
    d: "M618.2,257.5L618.2,257.5c-27.4,0-49.5-22.2-49.5-49.5v-9.7c0-4.4,1.7-8.6,4.8-11.7l15-15 c3.2-3.2,7.5-5,12-4.9c26.4,0.8,49.8,6.5,62.5,19c3.1,3.1,4.8,7.3,4.8,11.7V208C667.7,235.3,645.6,257.5,618.2,257.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6AF78"
    },
    d: "M593.4,200.4c0-9.5,8-17.1,17.5-16.5c16.7,1.1,41.4,3.9,56.6,11.1c-0.5-3.5-2-6.8-4.5-9.3 c-12.8-12.5-36.1-18.1-62.5-19l0,0v0c-4.5-0.1-8.8,1.7-12,4.9l-15,15c-3.1,3.1-4.8,7.3-4.8,11.7v9.7c0,22.6,15.1,41.6,35.8,47.6 c-6.9-8.5-11-19.3-11-31.1L593.4,200.4L593.4,200.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M667.7,329.1c0-6.6,2.6-12.9,7.3-17.5l21.3-21.3c2.8,4.1,4.5,9,4.5,14.2v60.4c0,4.6-3.7,8.3-8.3,8.3 h-24.8V329.1L667.7,329.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959CB5"
    },
    d: "M622.3,302.3h-8.3c-2.3,0-4.1-1.8-4.1-4.1v-12.4h16.5v12.4C626.4,300.5,624.6,302.3,622.3,302.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M618.2,285.7l-14,10.7c-2.4,1.8-5.9,1.1-7.4-1.6l-12.6-22.9l5.1-7.7c1.1-1.7,3.5-2,5-0.6 L618.2,285.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M618.2,285.7l14,10.7c2.4,1.8,5.9,1.1,7.4-1.6l12.6-22.9l-5.1-7.7c-1.1-1.7-3.5-2-5-0.6 L618.2,285.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "newClassroomIconSmallGirl2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A4146"
    },
    d: "M369.8,238.3c-7.1-18.7-12.7-50.8-13.9-67.6c-2.3-31.8-26.3-57.8-58.7-57.8s-56.4,26-58.7,57.8 c-1.2,16.7-6.8,48.9-13.9,67.6c-1.6,4.1,0.2,8.7,4.3,10.5c7.6,3.4,23.7,10.1,43.1,12.8h50.3c19.4-2.6,35.6-9.3,43.1-12.8 C369.6,247,371.4,242.4,369.8,238.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#694B4B"
    },
    d: "M365.5,248.8c4.1-1.8,5.9-6.4,4.3-10.5c-7.1-18.7-12.7-50.8-13.9-67.6 c-2.3-31.8-26.3-57.8-58.7-57.8c-0.1,0-0.2,0-0.2,0c-24.9,0.1-33.7,34.1-12.3,46.7c1.3,0.8,2.1,1.1,2.1,1.1l18.8,100.8h16.8 C341.7,258.9,358,252.2,365.5,248.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6AF78"
    },
    d: "M356.9,278.1l-26.7-13.4c-5.6-2.8-9.1-8.5-9.1-14.8l0-24.8h-49.5V250c0,6.3-3.5,12-9.1,14.8 l-26.7,13.4c-8.4,4.2-13.7,12.8-13.7,22.2v48.8c0,4.6,3.7,8.3,8.3,8.3h132.1c4.6,0,8.3-3.7,8.3-8.3v-48.8 C370.6,290.9,365.3,282.3,356.9,278.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D29B6E"
    },
    d: "M296.3,258.3c8.9,0,17.4-1.8,25.2-5.1c-0.2-1-0.4-2.1-0.4-3.2l0-24.8h-49.5V250 c0,1.1-0.2,2.1-0.4,3.2C278.9,256.4,287.4,258.3,296.3,258.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DCED"
    },
    d: "M356.9,278.1l-19-9.5c-8.8,13.6-24.1,22.7-41.6,22.7c-17.4,0-32.8-9-41.6-22.7l-19,9.5 c-8.4,4.2-13.7,12.8-13.7,22.2v48.8c0,4.6,3.7,8.3,8.3,8.3h132.1c4.6,0,8.3-3.7,8.3-8.3v-48.8C370.6,290.9,365.3,282.3,356.9,278.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C087"
    },
    d: "M296.3,241.7L296.3,241.7c-25.2,0-46-18.8-49.1-43.1c-0.5-3.5,1.2-7,4.4-8.6 c3.8-1.9,9.3-5.2,14.6-9.9c5.9-5.3,9.3-10.8,11.3-14.9c1.7-3.5,5.5-5.5,9.3-4.5c29.1,7.4,48.9,22.5,56.1,28.7 c1.9,1.7,3,4.1,2.8,6.6C343.7,221.7,322.4,241.7,296.3,241.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6AF78"
    },
    d: "M342.9,189.5c-7.2-6.2-27-21.3-56.1-28.7c-3.8-1-7.6,1-9.3,4.5c-1.5,3.1-3.9,7-7.5,11c0,0,0,0,0,0 c-1.1,1.3-2.3,2.6-3.7,3.8c-5.3,4.7-10.8,8-14.6,9.9c-3.2,1.6-4.9,5.1-4.4,8.6c2.8,21.9,19.9,39.3,41.6,42.6 c-9.9-6.7-17.3-16-17.3-32.5v-11.8c1.9-1.4,3.8-2.8,5.7-4.5c4.6-4.1,8.6-8.8,11.8-13.9c22.2,6.9,37.3,18.5,43,23.4 c1.6,1.4,5.4,5,10,9.2c2-4.7,3.2-9.8,3.7-15.1C345.9,193.6,344.8,191.1,342.9,189.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M227,285.4c-3.2,4.2-5,9.4-5,14.9v48.8c0,4.6,3.7,8.3,8.3,8.3H255v-41.6c0-5-2.3-9.8-6.2-12.9 L227,285.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "newClassroomIconBigBoy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8500"
    },
    d: "M743.7,317l-73.8-26.8l-52.9,17.6L564,290.2L490.2,317c-13.9,5.1-23.2,18.3-23.2,33.2v54.7 c0,4.9,3.9,8.8,8.8,8.8h282.3c4.9,0,8.8-4,8.8-8.8v-54.7C766.9,335.3,757.6,322.1,743.7,317z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#707487"
    },
    points: "607.7,325.5 599.3,413.7 634.5,413.7 626.1,325.5  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M626.2,337.6h-18.5c-3.4,0-6.2-2.8-6.2-6.2v-23.6h30.9v23.6C632.3,334.8,629.6,337.6,626.2,337.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB7100"
    },
    d: "M757.4,326.1c6,6.4,9.5,14.9,9.5,24v54.7c0,4.9-3.9,8.8-8.8,8.8h-44.1v-29.5c0-9.4,3.7-18.3,10.3-25 L757.4,326.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A4146"
    },
    d: "M713.9,108.2V34.3c0-9.7-7.9-17.6-17.6-17.6H590.4c-39,0-70.6,31.6-70.6,70.6v21 c0,9.5,1.5,18.9,4.5,27.9l2.9,8.8c0.9,2.7,1.4,5.5,1.4,8.4v4.5h176.4v-4.5c0-2.8,0.5-5.7,1.4-8.4l2.9-8.8 C712.4,127.1,713.9,117.7,713.9,108.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#694B4B"
    },
    d: "M564,52.5c0,19.8,16,35.8,35.8,35.8h5l2.4,69.5h98v-4.5c0-2.8,0.5-5.7,1.4-8.4l2.9-8.8 c3-9,4.5-18.4,4.5-27.9V34.3c0-9.7-7.9-17.6-17.6-17.6h-96.5C580,16.7,564,32.7,564,52.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564,
    y: 228.4,
    style: {
      fill: "#E6AF78"
    },
    width: 105.9,
    height: 79.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D29B6E"
    },
    d: "M564,258.2c15.6,9,33.6,14.3,52.9,14.3c19.3,0,37.3-5.3,52.9-14.3v-29.8H564L564,258.2L564,258.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB7100"
    },
    d: "M616.9,307.8l-28.1,28.1c-3.8,3.8-10,3.4-13.3-0.9l-29.2-38.4l7.6-16.1c2.3-4.7,8.1-6.5,12.6-3.7 L616.9,307.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB7100"
    },
    d: "M616.9,307.8l28.1,28.1c3.8,3.8,10,3.4,13.3-0.9l29.2-38.4l-7.6-16.1c-2.3-4.7-8.1-6.5-12.6-3.7 L616.9,307.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C087"
    },
    d: "M616.9,254.9L616.9,254.9c-48.7,0-88.2-39.5-88.2-88.2v-10.3c0-4.7,1.9-9.2,5.2-12.5l7.3-7.3 c3.3-3.3,5.2-7.8,5.2-12.5v-21.1c0-4.1,2.7-7.6,6.7-8.6c20.9-4.9,85.8-16.6,130,15.9c2.9,2.1,4.5,5.6,4.5,9.1v4.7 c0,4.7,1.9,9.2,5.2,12.5l7.3,7.3c3.3,3.3,5.2,7.8,5.2,12.5v10.3C705.1,215.4,665.6,254.9,616.9,254.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6AF78"
    },
    d: "M683,110.2c-31.1-22.9-72.4-23.8-101.4-20.7c-12.3,1.3-22.4,3.4-28.6,4.8c-4,0.9-6.7,4.5-6.7,8.6 v21.1c0,4.7-1.9,9.2-5.2,12.5l-7.3,7.3c-3.3,3.3-5.2,7.8-5.2,12.5v10.3c0,45.1,33.9,82.2,77.6,87.5c-15.2-15.9-24.6-37.3-24.6-61 v-64.5c0-8.9,6.6-16.4,15.5-17.5c21.2-2.7,59.9-4.3,90.3,12.9v-4.7C687.5,115.8,685.9,112.3,683,110.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB7100"
    },
    d: "M476.4,326.1c-6,6.4-9.5,14.9-9.5,24v54.7c0,4.9,3.9,8.8,8.8,8.8h44.1v-29.5c0-9.4-3.7-18.3-10.3-25 L476.4,326.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "newClassroomIconBigGirl"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#694B4B"
    },
    d: "M293.1,16.3c-139.6,0-124.2,169.8-123.5,292.9c0,4.6,2.5,8.8,6.4,11.2c15.5,9.3,58,31.1,117.1,31.1 s101.6-21.8,117.1-31.1c4-2.4,6.4-6.6,6.4-11.2C417.3,186.1,432.7,16.3,293.1,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A4146"
    },
    d: "M284.1,16.7C154.2,24,169,188.9,169.6,309.2c0,4.6,2.5,8.8,6.4,11.2c15.5,9.3,58,31.1,117.1,31.1 l35.3-247"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#694B4B"
    },
    d: "M293.1,16.3c-79.4,0-84.9,95.9-84.9,95.9c45.8-7.7,73.9,11.6,120.2-7.7l-35.3,247 c59.1,0,101.6-21.8,117.1-31.1c4-2.4,6.4-6.6,6.4-11.2C417.3,186.1,432.7,16.3,293.1,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#785550"
    },
    d: "M416.6,309.2c0.5-105.7,12-245.9-73.4-283.3c-1.5,7.7-4.2,29.3,2.8,43.3 c17.6,35.3,35.3,35.3,52.9,61.8c17.6,97-33.7,200-50.8,214.1l0,0c30.2-7.2,51.9-18.6,62-24.6C414.2,318,416.6,313.8,416.6,309.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6AF78"
    },
    d: "M426.8,336l-78.7-32.8c-6.6-2.7-10.9-9.2-10.9-16.3v-21.3H249v21.3c0,7.1-4.3,13.5-10.9,16.3 L159.4,336c-9.9,4.1-16.3,13.7-16.3,24.4v35.3c0,9.7,7.9,17.6,17.6,17.6h264.7c9.7,0,17.6-7.9,17.6-17.6v-35.3 C443.1,349.7,436.6,340.1,426.8,336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F9DC7"
    },
    d: "M426.8,336l-76.1-31.7l-57.6,24.8l-57.6-24.8L159.4,336c-9.9,4.1-16.3,13.7-16.3,24.4v35.3 c0,9.7,7.9,17.6,17.6,17.6h264.7c9.7,0,17.6-7.9,17.6-17.6v-35.3C443.1,349.7,436.6,340.1,426.8,336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D29B6E"
    },
    d: "M337.2,265.6H249v21.3c0,7.1-4.3,13.5-10.9,16.3l-12.3,5.1C319.9,332.3,337.2,265.6,337.2,265.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A8EBF"
    },
    d: "M186.1,370.1l-35.4-28.2c-4.7,4.9-7.6,11.4-7.6,18.5v35.3c0,9.7,7.9,17.6,17.6,17.6h35.3v-22.6 C196.1,382.7,192.4,375.1,186.1,370.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A8EBF"
    },
    d: "M443.1,395.7v-35.3c0-7-2.8-13.5-7.5-18.4l-35.5,28.1c-6.3,5-9.9,12.6-9.9,20.7v22.6h35.3 C435.2,413.3,443.1,405.4,443.1,395.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A8EBF"
    },
    d: "M293.1,395.7L293.1,395.7c-4.9,0-8.8-4-8.8-8.8v-57.7h17.6v57.7C301.9,391.7,298,395.7,293.1,395.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A8EBF"
    },
    d: "M293.1,329.1l-50.5-37.9c-3.2-2.4-7.9-1.6-10.1,1.7l-10,15l31,43.3c2.4,3.3,7,3.9,10.2,1.4 L293.1,329.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A8EBF"
    },
    d: "M293.1,329.1l50.5-37.9c3.2-2.4,7.9-1.6,10.1,1.7l10,15l-31,43.3c-2.4,3.3-7,3.9-10.2,1.4 L293.1,329.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C087"
    },
    d: "M337.2,95.7c-44.1,44.1-130.7,8.8-130.7,79.4l5.5,52c1.1,11.6,7.8,22,18,27.7l50.2,27.9 c8,4.4,17.7,4.4,25.7,0l50.2-27.9c10.2-5.7,16.9-16,18-27.7l6.3-61.7c0.5-4.4,0.5-8.8,0.4-13.2C377.6,129.7,346,113.4,337.2,95.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6AF78"
    },
    d: "M206.5,175.1l5.5,52c1.1,11.6,7.8,22,18,27.7l50.2,27.9c5.5,3.1,11.9,3.9,18,2.7l0,0 c0,0-25.3-7.7-40.4-48.5c-4.6-12.5-11-78.7-5.5-86.8c10.9-16,71.7-17.6,89.6-47.3c-0.9-1.1-1.7-2.2-2.5-3.3 c-0.1-0.1-0.1-0.2-0.2-0.3c-0.8-1.2-1.5-2.3-2.1-3.5C293.1,139.8,206.5,104.5,206.5,175.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6597C1"
    },
    d: "M363.7,395.7h-35.3c-4.9,0-8.8,4-8.8,8.8v8.8h52.9v-8.8C372.5,399.6,368.5,395.7,363.7,395.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "newClassroomIconAddButton"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8DC640"
    },
    d: "M514.7,378.6c-23.4,19.1-96.4,19.1-119.3,0c-23.4-19.1-21-100.7,0-122.2s98.3-21.5,119.3,0 C535.7,277.9,538,359.5,514.7,378.6z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M455.5,345.2c-21,16.7-44.4,25.3-66.3,25.8c-16.2-27.7-12.9-95,6.2-114.5 c17.2-17.7,71.1-21,102.1-10C505.1,277.9,489.4,318,455.5,345.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M500.3,316.6c0,4.8-3.8,8.6-8.6,8.6h-28.6v28.6c0,4.8-3.8,8.6-8.6,8.6c-4.8,0-8.6-3.8-8.6-8.6v-28.6 h-28.6c-4.8,0-8.6-3.8-8.6-8.6c0-4.8,3.8-8.6,8.6-8.6h28.6v-28.6c0-4.8,3.8-8.6,8.6-8.6c4.8,0,8.6,3.8,8.6,8.6V308h28.6 C496.5,308,500.3,311.8,500.3,316.6z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddClassroom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-classroom.2000abb0.svg";
export { ForwardRef as ReactComponent };